import classNames from 'classnames/bind';
import React, { FC } from 'react';
import { UploadFileWithAttachment } from 'api/attachments';
import { Attachment } from './attachment';
import styles from './attachment-gallery.module.css';

type AttachmentGalleryProps = {
  filesList: UploadFileWithAttachment[];
  large?: boolean;
  className?: string;
  onRemoveFile(file: UploadFileWithAttachment): void;
  onDownloadFile?(file: UploadFileWithAttachment): void;
  isBasicPreview?: boolean;
};

export const AttachmentGallery: FC<AttachmentGalleryProps> = ({
  className,
  filesList,
  onRemoveFile,
  onDownloadFile,
  large,
  isBasicPreview,
}) => {
  const cx = classNames.bind(styles);
  const galleryClassNames = cx(styles.list, className);

  return (
    <div className={galleryClassNames}>
      {filesList.map((file) => {
        return (
          <Attachment
            file={file}
            onRemoveFile={onRemoveFile}
            key={file.uid}
            large={large}
            onDownloadFile={onDownloadFile}
            isBasicPreview={isBasicPreview ?? !file.attachment?.sourceType}
          />
        );
      })}
    </div>
  );
};
